module.exports = __webpack_public_path__ + "assets/img/license.2b2d4236.jpg";